import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { HStack, LabelText, theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const PartnerLineItemAllergens = (props: Props) => {
  const { children, title } = props;

  // ─────────────────────────────────────────────────────────────────────

  return (
    <View style={styles.container}>
      <LabelText sizeMatch={['14']} style={styles.title}>
        {title}
      </LabelText>

      <HStack gap={theme.spacing['2']}>{children}</HStack>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    alignSelf: 'stretch',
    gap: theme.spacing['4'],
  },
  title: {
    color: theme.colors.CHARCOAL,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{ title: string }>;
